module.exports = [["value","label","vendors[]"],["none","No Thanks",""]]